import * as GTM4Enum from "./GTM4Enum";

function bind() {
    function beginCheckout() {
        const gtm4Event = window.gtm4Event;
        gtm4Event.event = GTM4Enum.BEGIN_CHECKOUT;
        window.dataLayer.push(gtm4Event)
    }
    window.beginCheckout = beginCheckout;

}

export {
    bind
}